import { render } from "./row.vue?vue&type=template&id=b8ff70be&scoped=true"
import script from "./row.vue?vue&type=script&lang=js"
export * from "./row.vue?vue&type=script&lang=js"

import "./row.vue?vue&type=style&index=0&id=b8ff70be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8ff70be"]])

export default __exports__